import React, { FC } from 'react';
import { useForm } from 'react-hook-form';
import { useModal } from 'store/modal';
import CreateEntity from 'components/crud/CreateEntity';
import UserForm from '../../components/UserForm';
import { IDropdowns, IInputs } from '../../components/types';

interface IProps {
  userDataOptions: IDropdowns;
}

const CreateForm: FC<IProps> = ({ userDataOptions }: IProps) => {
  const { showModal } = useModal();
  const methods = useForm<IInputs>();

  return (
    <CreateEntity
      entity="users"
      methods={methods}
      onSuccess={(res: any) => {
        const { first_name: firstName, last_name: lastName } = res.data;
        showModal({
          type: 'success',
          content: (
            <>
              Създадохте оператор&nbsp;
              <span className="font-weight-bold text-break">
                {firstName} {lastName}
              </span>
              .
            </>
          ),
        });
      }}
      queryKey="users"
      onSuccessPushToLink="/users"
    >
      {(create: any) => (
        <UserForm
          methods={methods}
          handleSubmit={data => {
            const formatData = {
              ...data,
              account_status: data.account_status.value,
            };
            return create(formatData);
          }}
          btnLabel="Запази"
          userDataOptions={userDataOptions}
        />
      )}
    </CreateEntity>
  );
};

export default CreateForm;
